var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.794 1.707C15.16 1.073 15.62 0 16.501 0C16.757 0 17.013 0.098 17.208 0.293L21.451 4.535C21.842 4.926 21.842 5.558 21.451 5.949C21.06 6.34 20.428 6.34 20.037 5.949L15.794 1.707ZM13.983 11H2.563L2.118 10.555C1.906 10.342 1.989 9.946 2.306 9.834C8.477 8.477 11.681 8.573 15.879 4.42L14.465 3.006C10.681 6.8 7.234 6.718 1.638 7.95C0.609 8.316 0 9.267 0 10.272C0 10.877 0.224 11.489 0.705 11.969L10.006 21.27C10.486 21.75 11.097 22 11.702 22C12.702 22 13.657 21.371 14.025 20.336C15.26 14.719 14.909 11.048 18.708 7.25L17.294 5.836C15.562 7.568 14.605 9.234 13.983 11ZM24 12.517C24 13.88 22.894 15 21.53 15C18.539 15 17.47 10.78 22.442 7C22.384 9.365 24 10.302 24 12.517ZM21.629 9.051C21.283 9.24 20.773 9.749 20.695 10.384C20.58 11.334 21.562 11.614 21.648 10.34C21.688 9.803 21.648 9.546 21.629 9.051Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearch);
export default __webpack_public_path__ + "static/media/research.e396da78a6d702101067e7fbab0a5cb1.svg";
export { ForwardRef as ReactComponent };